import React from "react";

export default function NavGuard() {
  return (
    <div
      id="nav-guard"
      aria-hidden="true"
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "22vh",
        height: 1,
        pointerEvents: "none",
      }}
    />
  );
}
